import { render, staticRenderFns } from "./SetNewPassword.vue?vue&type=template&id=9713a20a&scoped=true"
import script from "./SetNewPassword.vue?vue&type=script&lang=js"
export * from "./SetNewPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9713a20a",
  null
  
)

export default component.exports